import RateCardDetail from "pages/shipper/Settings/components/RateCardDetail/RateCardDetail";
import {
  Notifications as ShipperNotifications,
  AddressBook,
  ContactList,
  PresetsAndTemplates,
  PaymentLocations,
  ProviderContainer,
  ApprovalLevels,
  Prefills,
  LocationApprovalLevels,
  TeamMembers,
  RateCards,
  FileImportTools,
  InvoiceAttachmentBucket,
  ParcelAccounts,
  CreateParcelAccount,
  EditParcelAccount,
  EmailNotifications,
} from "../../shipper/Settings/components";
import {
  AccountMapping,
  DocumentsAgreements,
  Notifications as ProviderNotifications,
  Teams,
  Users,
} from "../../provider/Settings/components";
import { YourDetails, CompanyDetails, UserRole, DeveloperApiTokens } from "./components";

const settingsRoutes = [
  { path: "/your-details", component: YourDetails, userType: ["shipper", "provider"], name: "YourDetails" },
  { path: "/user-roles", component: UserRole, userType: ["shipper", "provider"], name: "UserRoles" },
  {
    path: "/email-notifications",
    component: EmailNotifications,
    userType: ["shipper"],
    name: "EmailNotifications",
  },
  { path: "/company-details", component: CompanyDetails, userType: ["shipper", "provider"], name: "CompanyDetails" },
  { path: "/notifications", component: ShipperNotifications, userType: ["shipper"], name: "ShipperNotifications" },
  { path: "/address-book", component: AddressBook, userType: ["shipper"], name: "AddressBook" },
  { path: "/contact-list", component: ContactList, userType: ["shipper"], name: "ContactList" },
  { path: "/presets-templates", component: PresetsAndTemplates, userType: ["shipper"], name: "PresetList" },
  { path: "/team-members", component: TeamMembers, userType: ["shipper"], name: "TeamMembers" },
  { path: "/payment-location-settings", component: PaymentLocations, userType: ["shipper"], name: "PaymentLocations" },
  { path: "/providers/*", component: ProviderContainer, userType: ["shipper"], name: "ProviderContainer" },
  { path: "/approval-levels", component: ApprovalLevels, userType: ["shipper"], name: "ApprovalLevels" },
  {
    path: "/invoice-attachment-buckets",
    component: InvoiceAttachmentBucket,
    userType: ["shipper"],
    name: "InvoiceAttachmentBucket",
  },
  {
    path: "/approval-levels/:location",
    component: LocationApprovalLevels,
    userType: ["shipper"],
    name: "LocationApprovalLevels",
  },
  { path: "/prefills", component: Prefills, userType: ["shipper"], name: "Prefills" },
  { path: "/rate-cards", component: RateCards, userType: ["shipper"], name: "RateCards" },
  { path: "/rate-card/:id/*", component: RateCardDetail, userType: ["shipper"], name: "RateCardDetail" },
  { path: "/documents-agreements", component: DocumentsAgreements, userType: ["provider"], name: "DocumentsAgreements" },
  { path: "/notifications", component: ProviderNotifications, userType: ["provider"], name: "ProviderNotifications" },
  { path: "/teams", component: Teams, userType: ["provider"], name: "Teams" },
  { path: "/users", component: Users, userType: ["provider"], name: "Users" },
  { path: "/account-mapping", component: AccountMapping, userType: ["provider"], name: "AccountMapping" },
  { path: "/file-import-tools", component: FileImportTools, userType: ["shipper"], name: "FileImportTools" },
  { path: "/parcel-accounts", component: ParcelAccounts, userType: ["shipper"], name: "ParcelAccounts" },
  { path: "/parcel-accounts/add", component: CreateParcelAccount, userType: ["shipper"], name: "CreateParcelAccount" },
  { path: "/parcel-accounts/:id", component: EditParcelAccount, userType: ["shipper"], name: "EditParcelAccount" },
  { path: "/api-tokens", component: DeveloperApiTokens, userType: ["shipper", "provider"], name: "DeveloperApiTokens" },
];

export default settingsRoutes;
